<div #myname class="disable-pull-to-refresh">
    <router-outlet></router-outlet>
</div>